module.exports = __webpack_public_path__ + "static/internet-of-things.4b3af02b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/internet-of-things.png
// module id = 798
// module chunks = 146230036245944